import * as t from "io-ts";

/** A verification channel the financing gate may offer. */
export const VerificationChannel = t.keyof({
    email: null,
    sms: null,
    voice: null,
});
export type VerificationChannel = t.TypeOf<typeof VerificationChannel>;

/**
 * Response from the verification status endpoint, used by the channel-picker
 * gate to decide whether to auto-pass before showing a picker.
 *
 * Modeled as a discriminated union over `status`: only the `needs` branch
 * carries (and requires) `channels`, the list of methods to offer. The server
 * returns `channels` in every branch, but io-ts `t.type` ignores excess props
 * on the satisfied/exempt branch, so decoding still succeeds.
 */
export const VerificationStatusResponse = t.union([
    t.readonly(
        t.type({
            status: t.literal("needs"),
            channels: t.readonlyArray(VerificationChannel),
        }),
    ),
    t.readonly(
        t.type({
            status: t.keyof({ satisfied: null, exempt: null }),
        }),
    ),
]);
export type VerificationStatusResponse = t.TypeOf<
    typeof VerificationStatusResponse
>;
